// import React, { useState, useEffect, useRef } from "react";
// // import { BASE_URL } from './config'; // Adjust path as needed

// import { BASE_URL, DOMAIN_URL } from "../../config";
// const BlogDelete = ({ onNavigate }) => {
//   const [isMenuOpen, setIsMenuOpen] = useState(false);
//   const [isAnimating, setIsAnimating] = useState(false);
//   const [openPostMenus, setOpenPostMenus] = useState({});
//   const [deletedPosts, setDeletedPosts] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const menuRef = useRef(null);

//   // Pagination state
//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 6;

//   // Calculate pagination
//   const totalPages = Math.ceil(deletedPosts.length / itemsPerPage);
//   const startIndex = (currentPage - 1) * itemsPerPage;
//   const endIndex = startIndex + itemsPerPage;
//   const currentPosts = deletedPosts.slice(startIndex, endIndex);
//   // Extract token from URL and store in localStorage
//   useEffect(() => {
//     const urlParams = new URLSearchParams(window.location.search);
//     const urlToken = urlParams.get("token");

//     if (urlToken) {
//       localStorage.setItem("authToken", urlToken);
//     }
//   }, []);
//   // Auto-load deleted posts on component mount
//   useEffect(() => {
//     fetchDeletedPosts();
//   }, []);

//   // Update the fetchDeletedPosts function
//   const fetchDeletedPosts = async () => {
//     setLoading(true);
//     setError(null);

//     try {
//       // Get token from URL params (same as in Blog.jsx)
//       const urlParams = new URLSearchParams(window.location.search);
//       const token = urlParams.get("token");

//       console.log("Fetching deleted posts with token:", token ? "YES" : "NO");

//       const response = await fetch(`${BASE_URL}/blogs/deleted`, {
//         method: "GET",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//       });

//       console.log("Deleted posts response status:", response.status);

//       if (response.ok) {
//         const data = await response.json();
//         console.log("Deleted posts data:", data);
//         setDeletedPosts(data.blogs || data.data || []);
//       } else {
//         const errorData = await response.json();
//         console.error("Error fetching deleted posts:", errorData);
//         setError(errorData.message || "Failed to fetch deleted posts");
//       }
//     } catch (err) {
//       console.error("Error fetching deleted posts:", err);
//       setError("Error fetching deleted posts: " + err.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Update the handlePostAction function
//   const handlePostAction = async (action, postId) => {
//     setOpenPostMenus({});

//     if (action === "restore") {
//       try {
//         const urlParams = new URLSearchParams(window.location.search);
//         const token = urlParams.get("token");

//         console.log("=== RESTORE DEBUG ===");
//         console.log("Post ID:", postId);
//         console.log("Token present:", !!token);
//         console.log("Full URL:", `${BASE_URL}/blogs/${postId}/restore`);

//         const response = await fetch(`${BASE_URL}/blogs/${postId}/restore`, {
//           method: "PATCH",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//         });

//         console.log("Response status:", response.status);
//         console.log(
//           "Response headers:",
//           Object.fromEntries(response.headers.entries())
//         );

//         // Get response body regardless of success/failure
//         const responseText = await response.text();
//         console.log("Response body:", responseText);

//         if (response.ok) {
//           const result = JSON.parse(responseText);
//           console.log("Restore successful:", result);
//           setDeletedPosts((prev) =>
//             prev.filter((post) => post.blog_id !== postId)
//           );
//           alert("Blog post restored successfully");
//         } else {
//           console.error("Restore failed with status:", response.status);
//           try {
//             const errorData = JSON.parse(responseText);
//             console.error("Error details:", errorData);
//             alert(
//               "Failed to restore: " + (errorData.message || "Unknown error")
//             );
//           } catch (parseError) {
//             console.error("Could not parse error response:", responseText);
//             alert("Failed to restore: Server error");
//           }
//         }
//       } catch (error) {
//         console.error("Network/fetch error:", error);
//         alert("Network error: " + error.message);
//       }
//     }

//     // Your existing delete-forever code remains the same

//     if (action === "delete-forever") {
//       const confirmed = window.confirm(
//         "Are you sure you want to permanently delete this blog post? This action cannot be undone."
//       );

//       if (confirmed) {
//         try {
//           const urlParams = new URLSearchParams(window.location.search);
//           const token = urlParams.get("token");

//           const response = await fetch(
//             `${BASE_URL}/blogs/${postId}/permanent`,
//             {
//               method: "DELETE",
//               headers: {
//                 "Content-Type": "application/json",
//                 Authorization: `Bearer ${token}`,
//               },
//             }
//           );

//           if (response.ok) {
//             const result = await response.json();
//             console.log("Blog permanently deleted:", result.message);

//             // Remove from deleted posts list
//             setDeletedPosts((prev) =>
//               prev.filter((post) => post.blog_id !== postId)
//             );

//             alert("Blog post permanently deleted");
//           } else {
//             const errorData = await response.json();
//             console.error("Failed to permanently delete blog post:", errorData);
//             alert(
//               "Failed to permanently delete blog post: " + errorData.message
//             );
//           }
//         } catch (error) {
//           console.error("Error permanently deleting blog post:", error);
//           alert("Error permanently deleting blog post: " + error.message);
//         }
//       }
//     }
//   };

//   const handleNavigation = (view) => {
//     setIsAnimating(true);
//     setIsMenuOpen(false);
//     setTimeout(() => {
//       onNavigate(view);
//       setIsAnimating(false);
//     }, 150);
//   };
//   // Handle post menu toggle
//   const togglePostMenu = (postId) => {
//     setOpenPostMenus((prev) => ({
//       ...prev,
//       [postId]: !prev[postId],
//     }));
//   };
//   // Pagination handlers
//   const goToPage = (page) => {
//     setCurrentPage(page);
//   };

//   const goToPrevious = () => {
//     if (currentPage > 1) {
//       setCurrentPage(currentPage - 1);
//     }
//   };

//   const goToNext = () => {
//     if (currentPage < totalPages) {
//       setCurrentPage(currentPage + 1);
//     }
//   };

//   return (
//     <div className="h-screen flex flex-col bg-gray-50">
//       {/* Header */}
//       <div className="flex-shrink-0 bg-white shadow-sm border-b">
//         <div className="px-4 py-4">
//           <div className="flex items-center justify-between">
//             {/* Navigation Menu */}
//             <div className="relative" ref={menuRef}>
//               <button
//                 onClick={() => setIsMenuOpen(!isMenuOpen)}
//                 className="p-2 hover:bg-gray-100 rounded transition-colors"
//               >
//                 <svg
//                   className="w-6 h-6"
//                   fill="none"
//                   stroke="currentColor"
//                   viewBox="0 0 24 24"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M4 6h16M4 12h16M4 18h16"
//                   />
//                 </svg>
//               </button>

//               {isMenuOpen && (
//                 <div className="absolute top-full left-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 z-50 overflow-hidden">
//                   <div className="py-2">
//                     <button
//                       onClick={() => handleNavigation("home")}
//                       className="w-full text-left px-4 py-3 hover:bg-gray-50 transition-colors flex items-center text-gray-700"
//                     >
//                       <svg
//                         className="w-4 h-4 mr-3"
//                         fill="none"
//                         stroke="currentColor"
//                         viewBox="0 0 24 24"
//                       >
//                         <path
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                           strokeWidth={2}
//                           d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2H5a2 2 0 00-2-2z"
//                         />
//                       </svg>
//                       Home
//                     </button>

//                     <button className="w-full text-left px-4 py-3 hover:bg-gray-50 transition-colors flex items-center bg-red-50 text-red-600 border-r-2 border-red-600">
//                       <svg
//                         className="w-4 h-4 mr-3"
//                         fill="none"
//                         stroke="currentColor"
//                         viewBox="0 0 24 24"
//                       >
//                         <path
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                           strokeWidth={2}
//                           d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
//                         />
//                       </svg>
//                       Delete
//                     </button>

//                     <button
//                       onClick={() => handleNavigation("archive")}
//                       className="w-full text-left px-4 py-3 hover:bg-gray-50 transition-colors flex items-center text-gray-700"
//                     >
//                       <svg
//                         className="w-4 h-4 mr-3"
//                         fill="none"
//                         stroke="currentColor"
//                         viewBox="0 0 24 24"
//                       >
//                         <path
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                           strokeWidth={2}
//                           d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h14a2 2 0 002-2V8m-9 4h4"
//                         />
//                       </svg>
//                       Archive
//                     </button>
//                   </div>
//                 </div>
//               )}
//             </div>

//             {/* Action Buttons */}
//             <div className="flex gap-4">
//               <span className="px-4 py-2 bg-red-100 text-red-700 rounded font-medium">
//                 Deleted Posts Management
//               </span>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Content Area */}
//       <div className="flex-1 overflow-auto">
//         <div
//           className={`px-4 py-6 transition-all duration-300 ${
//             isAnimating
//               ? "opacity-50 transform translate-x-4"
//               : "opacity-100 transform translate-x-0"
//           }`}
//         >
//           {/* Page Header */}
//           <div className="mb-6 flex justify-between items-center">
//             <h2 className="text-xl font-semibold text-gray-800">
//               Deleted Posts{" "}
//               {totalPages > 0 && `(Page ${currentPage} of ${totalPages})`}
//             </h2>
//             <p className="text-gray-600">
//               Showing {deletedPosts.length > 0 ? startIndex + 1 : 0}-
//               {Math.min(endIndex, deletedPosts.length)} of {deletedPosts.length}{" "}
//               posts
//             </p>
//           </div>

//           {/* Loading State */}
//           {loading && (
//             <div className="flex justify-center items-center py-16">
//               <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
//             </div>
//           )}

//           {/* Error State */}
//           {error && (
//             <div className="text-center py-16">
//               <p className="text-red-600 text-lg">
//                 Failed to fetch deleted posts
//               </p>
//               <p className="text-gray-600 mt-2">{error}</p>
//               <button
//                 onClick={fetchDeletedPosts}
//                 className="mt-4 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
//               >
//                 Try Again
//               </button>
//             </div>
//           )}

//           {/* Empty State */}
//           {!loading && !error && deletedPosts.length === 0 && (
//             <div className="flex flex-col items-center justify-center py-16">
//               <div className="text-6xl mb-4">🗑️</div>
//               <h3 className="text-xl font-semibold text-gray-800 mb-2">
//                 No deleted posts found
//               </h3>
//               <p className="text-gray-600">No deleted posts to show.</p>
//             </div>
//           )}

//           {/* Posts Grid */}
//           {!loading && !error && deletedPosts.length > 0 && (
//             <>
//               <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6 mb-8">
//                 {currentPosts.map((post, index) => (
//                   <div
//                     key={post.blog_id}
//                     className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow cursor-pointer opacity-75 border-2 border-red-200 relative"
//                   >
//                     {/* DELETED Badge */}
//                     <div className="p-2 bg-red-50 border-b border-red-100">
//                       <span className="text-xs text-red-600 font-medium">
//                         DELETED
//                       </span>
//                     </div>

//                     {/* Post Menu */}
//                     <div className="absolute top-12 right-3 z-10 post-menu">
//                       <button
//                         onClick={() => togglePostMenu(post.blog_id)}
//                         className="p-2 bg-white/95 hover:bg-white rounded-lg shadow-md transition-colors border border-gray-200"
//                       >
//                         <svg
//                           className="w-4 h-4"
//                           fill="none"
//                           stroke="currentColor"
//                           viewBox="0 0 24 24"
//                         >
//                           <path
//                             strokeLinecap="round"
//                             strokeLinejoin="round"
//                             strokeWidth={2}
//                             d="M4 6h16M4 12h16M4 18h16"
//                           />
//                         </svg>
//                       </button>

//                       {openPostMenus[post.blog_id] && (
//                         <div className="absolute top-full right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 z-50 overflow-hidden">
//                           <div className="py-2">
//                             <button
//                               onClick={() =>
//                                 handlePostAction("restore", post.blog_id)
//                               }
//                               className="w-full text-left px-4 py-2 hover:bg-green-50 transition-colors flex items-center text-green-600"
//                             >
//                               <svg
//                                 className="w-4 h-4 mr-3"
//                                 fill="none"
//                                 stroke="currentColor"
//                                 viewBox="0 0 24 24"
//                               >
//                                 <path
//                                   strokeLinecap="round"
//                                   strokeLinejoin="round"
//                                   strokeWidth={2}
//                                   d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
//                                 />
//                               </svg>
//                               Restore
//                             </button>

//                             <button
//                               onClick={() =>
//                                 handlePostAction("delete-forever", post.blog_id)
//                               }
//                               className="w-full text-left px-4 py-2 hover:bg-red-50 transition-colors flex items-center text-red-600"
//                             >
//                               <svg
//                                 className="w-4 h-4 mr-3"
//                                 fill="none"
//                                 stroke="currentColor"
//                                 viewBox="0 0 24 24"
//                               >
//                                 <path
//                                   strokeLinecap="round"
//                                   strokeLinejoin="round"
//                                   strokeWidth={2}
//                                   d="M6 18L18 6M6 6l12 12"
//                                 />
//                               </svg>
//                               Permanent Delete
//                             </button>
//                           </div>
//                         </div>
//                       )}
//                     </div>

//                     {/* Image */}
//                     <div className="relative">
//                       {post.main_image_url ? (
//                         <img
//                           src={post.main_image_url}
//                           alt={post.title}
//                           className="w-full h-[300px] min-h[300px] object-cover"
//                         />
//                       ) : (
//                         <div className="w-full h-50 bg-gradient-to-br from-red-100 to-red-200 flex items-center justify-center">
//                           <span className="text-gray-500 text-lg font-medium">
//                             No Image
//                           </span>
//                         </div>
//                       )}
//                     </div>

//                     {/* Content */}
//                     <div className="p-4">
//                       <div className="flex justify-between items-start text-xs text-gray-600 mb-2">
//                         <span className="px-2 py-1 rounded text-xs bg-red-100 text-red-800">
//                           {post.category?.category_name || "Uncategorized"}
//                         </span>
//                         <span>
//                           {new Date(post.created_at).toLocaleDateString()}
//                         </span>
//                       </div>
//                       <h3 className="font-semibold text-gray-800 mb-3 text-sm text-center line-clamp-2">
//                         {post.title}
//                       </h3>
//                       {post.deleted_at && (
//                         <p className="text-xs text-red-600 text-center">
//                           Deleted:{" "}
//                           {new Date(post.deleted_at).toLocaleDateString()}
//                         </p>
//                       )}
//                     </div>
//                   </div>
//                 ))}
//               </div>

//               {/* Pagination */}
//               {totalPages > 1 && (
//                 <div className="flex justify-center items-center gap-4 pb-16">
//                   <button
//                     onClick={goToPrevious}
//                     disabled={currentPage === 1}
//                     className="px-4 py-2 bg-white border border-gray-300 rounded disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-50"
//                   >
//                     Previous
//                   </button>

//                   <div className="flex gap-2">
//                     {Array.from({ length: totalPages }, (_, i) => i + 1).map(
//                       (page) => (
//                         <button
//                           key={page}
//                           onClick={() => goToPage(page)}
//                           className={`px-3 py-2 border rounded ${
//                             currentPage === page
//                               ? "bg-red-500 text-white border-red-500"
//                               : "bg-white border-gray-300 hover:bg-gray-50"
//                           }`}
//                         >
//                           {page}
//                         </button>
//                       )
//                     )}
//                   </div>

//                   <button
//                     onClick={goToNext}
//                     disabled={currentPage === totalPages}
//                     className="px-4 py-2 bg-white border border-gray-300 rounded disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-50"
//                   >
//                     Next
//                   </button>
//                 </div>
//               )}
//             </>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default BlogDelete;

import React, { useState, useEffect, useRef } from "react";
// import { BASE_URL } from './config'; // Adjust path as needed

import { BASE_URL, DOMAIN_URL } from "../../config";
const BlogDelete = ({ onNavigate }) => {

  const [isAnimating, setIsAnimating] = useState(false);
  const [openPostMenus, setOpenPostMenus] = useState({});
  const [deletedPosts, setDeletedPosts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 6;

  // Calculate pagination
  const totalPages = Math.ceil(deletedPosts.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentPosts = deletedPosts.slice(startIndex, endIndex);
  // Extract token from URL and store in localStorage
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const urlToken = urlParams.get("token");

    if (urlToken) {
      localStorage.setItem("authToken", urlToken);
    }
  }, []);
  // Auto-load deleted posts on component mount
  useEffect(() => {
    fetchDeletedPosts();
  }, []);

  // Update the fetchDeletedPosts function
  const fetchDeletedPosts = async () => {
    setLoading(true);
    setError(null);

    try {
      // Get token from URL params (same as in Blog.jsx)
      const urlParams = new URLSearchParams(window.location.search);
      const token = urlParams.get("token");

      console.log("Fetching deleted posts with token:", token ? "YES" : "NO");

      const response = await fetch(`${BASE_URL}/blogs/deleted`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      console.log("Deleted posts response status:", response.status);

      if (response.ok) {
        const data = await response.json();
        console.log("Deleted posts data:", data);
        setDeletedPosts(data.blogs || data.data || []);
      } else {
        const errorData = await response.json();
        console.error("Error fetching deleted posts:", errorData);
        setError(errorData.message || "Failed to fetch deleted posts");
      }
    } catch (err) {
      console.error("Error fetching deleted posts:", err);
      setError("Error fetching deleted posts: " + err.message);
    } finally {
      setLoading(false);
    }
  };

  // Update the handlePostAction function
  const handlePostAction = async (action, postId) => {
    setOpenPostMenus({});

    if (action === "restore") {
      try {
        const urlParams = new URLSearchParams(window.location.search);
        const token = urlParams.get("token");

        console.log("=== RESTORE DEBUG ===");
        console.log("Post ID:", postId);
        console.log("Token present:", !!token);
        console.log("Full URL:", `${BASE_URL}/blogs/${postId}/restore`);

        const response = await fetch(`${BASE_URL}/blogs/${postId}/restore`, {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        console.log("Response status:", response.status);
        console.log(
          "Response headers:",
          Object.fromEntries(response.headers.entries())
        );

        // Get response body regardless of success/failure
        const responseText = await response.text();
        console.log("Response body:", responseText);

        if (response.ok) {
          const result = JSON.parse(responseText);
          console.log("Restore successful:", result);
          setDeletedPosts((prev) =>
            prev.filter((post) => post.blog_id !== postId)
          );
          alert("Blog post restored successfully");
        } else {
          console.error("Restore failed with status:", response.status);
          try {
            const errorData = JSON.parse(responseText);
            console.error("Error details:", errorData);
            alert(
              "Failed to restore: " + (errorData.message || "Unknown error")
            );
          } catch (parseError) {
            console.error("Could not parse error response:", responseText);
            alert("Failed to restore: Server error");
          }
        }
      } catch (error) {
        console.error("Network/fetch error:", error);
        alert("Network error: " + error.message);
      }
    }

    // Your existing delete-forever code remains the same

    if (action === "delete-forever") {
      const confirmed = window.confirm(
        "Are you sure you want to permanently delete this blog post? This action cannot be undone."
      );

      if (confirmed) {
        try {
          const urlParams = new URLSearchParams(window.location.search);
          const token = urlParams.get("token");

          const response = await fetch(
            `${BASE_URL}/blogs/${postId}/permanent`,
            {
              method: "DELETE",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            }
          );

          if (response.ok) {
            const result = await response.json();
            console.log("Blog permanently deleted:", result.message);

            // Remove from deleted posts list
            setDeletedPosts((prev) =>
              prev.filter((post) => post.blog_id !== postId)
            );

            alert("Blog post permanently deleted");
          } else {
            const errorData = await response.json();
            console.error("Failed to permanently delete blog post:", errorData);
            alert(
              "Failed to permanently delete blog post: " + errorData.message
            );
          }
        } catch (error) {
          console.error("Error permanently deleting blog post:", error);
          alert("Error permanently deleting blog post: " + error.message);
        }
      }
    }
  };

  const handleNavigation = (view) => {
    setIsAnimating(true);
   
    setTimeout(() => {
      onNavigate(view);
      setIsAnimating(false);
    }, 150);
  };
  // Handle post menu toggle
  const togglePostMenu = (postId) => {
    setOpenPostMenus((prev) => ({
      ...prev,
      [postId]: !prev[postId],
    }));
  };
  // Pagination handlers
  const goToPage = (page) => {
    setCurrentPage(page);
  };

  const goToPrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const goToNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  return (
    <div className="h-screen flex flex-col bg-gray-50">
      {/* Header */}
      <div className="flex-shrink-0 bg-white shadow-sm border-b">
        <div className="px-4 py-4">
          <div className="flex items-center justify-between">
            {/* Navigation Menu */}
            {/* Tab Navigation */}
<div className="flex bg-gray-100 rounded-lg p-1">
  <button
    onClick={() => handleNavigation("home")}
    className="px-4 py-2 rounded-md text-sm font-medium transition-all duration-200 text-gray-600 hover:text-gray-800"
  >
    <svg
      className="w-4 h-4 inline mr-2"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2H5a2 2 0 00-2-2z"
      />
    </svg>
    Home
  </button>

  <button className="px-4 py-2 rounded-md text-sm font-medium transition-all duration-200 bg-white text-red-600 shadow-sm">
    <svg
      className="w-4 h-4 inline mr-2"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
      />
    </svg>
    Deleted
  </button>

  <button
    onClick={() => handleNavigation("archive")}
    className="px-4 py-2 rounded-md text-sm font-medium transition-all duration-200 text-gray-600 hover:text-gray-800"
  >
    <svg
      className="w-4 h-4 inline mr-2"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h14a2 2 0 002-2V8m-9 4h4"
      />
    </svg>
    Archive
  </button>
</div>
            {/* Action Buttons */}
            <div className="flex gap-4">
              <span className="px-4 py-2 bg-red-100 text-red-700 rounded font-medium">
                Deleted Posts Management
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Content Area */}
      <div className="flex-1 overflow-auto">
        <div
          className={`px-4 py-6 transition-all duration-300 ${
            isAnimating
              ? "opacity-50 transform translate-x-4"
              : "opacity-100 transform translate-x-0"
          }`}
        >
          {/* Page Header */}
          <div className="mb-6 flex justify-between items-center">
            <h2 className="text-xl font-semibold text-gray-800">
              Deleted Posts{" "}
              {totalPages > 0 && `(Page ${currentPage} of ${totalPages})`}
            </h2>
            <p className="text-gray-600">
              Showing {deletedPosts.length > 0 ? startIndex + 1 : 0}-
              {Math.min(endIndex, deletedPosts.length)} of {deletedPosts.length}{" "}
              posts
            </p>
          </div>

          {/* Loading State */}
          {loading && (
            <div className="flex justify-center items-center py-16">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
            </div>
          )}

          {/* Error State */}
          {error && (
            <div className="text-center py-16">
              <p className="text-red-600 text-lg">
                Failed to fetch deleted posts
              </p>
              <p className="text-gray-600 mt-2">{error}</p>
              <button
                onClick={fetchDeletedPosts}
                className="mt-4 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
              >
                Try Again
              </button>
            </div>
          )}

          {/* Empty State */}
          {!loading && !error && deletedPosts.length === 0 && (
            <div className="flex flex-col items-center justify-center py-16">
              <div className="text-6xl mb-4">🗑️</div>
              <h3 className="text-xl font-semibold text-gray-800 mb-2">
                No deleted posts found
              </h3>
              <p className="text-gray-600">No deleted posts to show.</p>
            </div>
          )}

          {/* Posts Grid */}
          {!loading && !error && deletedPosts.length > 0 && (
            <>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6 mb-8">
                {currentPosts.map((post, index) => (
                  <div
                    key={post.blog_id}
                    className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow cursor-pointer  border-2 border-red-200 relative"
                  >
                    {/* DELETED Badge */}
                    <div className="p-2 bg-red-50 border-b border-red-100">
                      <span className="text-xs text-red-600 font-medium">
                        DELETED
                      </span>
                    </div>

                    {/* Post Menu */}
                    <div className="absolute top-12 right-3 z-10 post-menu">
                     <button
  onClick={() => togglePostMenu(post.blog_id)}
  className="p-2 bg-white/95 hover:bg-gray-100 rounded-full transition-colors"
>
  <svg
    className="w-5 h-5 text-gray-500"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M12 5v.01M12 12v.01M12 19v.01"
    />
  </svg>
</button>

                      {openPostMenus[post.blog_id] && (
                        <div className="absolute top-full right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 z-50 overflow-hidden">
                          <div className="py-2">
                            <button
                              onClick={() =>
                                handlePostAction("restore", post.blog_id)
                              }
                              className="w-full text-left px-4 py-2 hover:bg-green-50 transition-colors flex items-center text-green-600"
                            >
                              <svg
                                className="w-4 h-4 mr-3"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth={2}
                                  d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                                />
                              </svg>
                              Restore
                            </button>

                            <button
                              onClick={() =>
                                handlePostAction("delete-forever", post.blog_id)
                              }
                              className="w-full text-left px-4 py-2 hover:bg-red-50 transition-colors flex items-center text-red-600"
                            >
                              <svg
                                className="w-4 h-4 mr-3"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth={2}
                                  d="M6 18L18 6M6 6l12 12"
                                />
                              </svg>
                              Permanent Delete
                            </button>
                          </div>
                        </div>
                      )}
                    </div>

                    {/* Image */}
                    <div className="relative">
                      {post.main_image_url ? (
                        <img
                          src={post.main_image_url}
                          alt={post.title}
                          className="w-full h-[300px] min-h[300px] object-cover"
                        />
                      ) : (
                        <div className="w-full h-50 bg-gradient-to-br from-red-100 to-red-200 flex items-center justify-center">
                          <span className="text-gray-500 text-lg font-medium">
                            No Image
                          </span>
                        </div>
                      )}
                    </div>

                    {/* Content */}
                    <div className="p-4">
                      <div className="flex justify-between items-start text-xs text-gray-600 mb-2">
                        <span className="px-2 py-1 rounded text-xs bg-red-100 text-red-800">
                          {post.category?.category_name || "Uncategorized"}
                        </span>
                        <span>
                          {new Date(post.created_at).toLocaleDateString()}
                        </span>
                      </div>
                      <h3 className="font-semibold text-gray-800 mb-3 text-sm text-center line-clamp-2">
                        {post.title}
                      </h3>
                      {post.deleted_at && (
                        <p className="text-xs text-red-600 text-center">
                          Deleted:{" "}
                          {new Date(post.deleted_at).toLocaleDateString()}
                        </p>
                      )}
                    </div>
                  </div>
                ))}
              </div>

              {/* Pagination */}
              {totalPages > 1 && (
                <div className="flex justify-center items-center gap-4 pb-16">
                  <button
                    onClick={goToPrevious}
                    disabled={currentPage === 1}
                    className="px-4 py-2 bg-white border border-gray-300 rounded disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-50"
                  >
                    Previous
                  </button>

                  <div className="flex gap-2">
                    {Array.from({ length: totalPages }, (_, i) => i + 1).map(
                      (page) => (
                        <button
                          key={page}
                          onClick={() => goToPage(page)}
                          className={`px-3 py-2 border rounded ${
                            currentPage === page
                              ? "bg-red-500 text-white border-red-500"
                              : "bg-white border-gray-300 hover:bg-gray-50"
                          }`}
                        >
                          {page}
                        </button>
                      )
                    )}
                  </div>

                  <button
                    onClick={goToNext}
                    disabled={currentPage === totalPages}
                    className="px-4 py-2 bg-white border border-gray-300 rounded disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-50"
                  >
                    Next
                  </button>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default BlogDelete;
